<div class="table-root-child">
    <div class="table-action-wrapper">
        <div class="table-action-inner d-flex align-items-center justify-content-between">
        <div class="d-flex">
            <div id="new_service_search" class="search-input">
                <img src="../../assets/icons/search.svg" alt="Search icon" (click)="search()" />
                <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchText"
                    (keydown.enter)="search()" (ngModelChange)="this.searchTextUpdate.next($event)" />
            </div>
            <div id="new_service_search-by" class="search-type-picker">
                <div class="dropdown search-type-dropdown" #stTrigger (click)="openDropdown('st', stTrigger)"
                    click-stop-propagation>
                    <span>{{'COMMON.BY' | translate}}:</span>
                    <span>{{ selectedSearchTypeDisplay | translate }}</span>
                    <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg"
                            alt="Gray arrow down" /></span>
                </div>
                <div class="dropdown-opened" *ngIf="showSelectSearchType" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
                    <div [id]="'new_service_search-by-' + (i + 1)" (click)="
                    selectSearchType(searchType)
                " *ngFor="let searchType of searchByOptions; let i = index">
                        <div>{{ searchType.translation | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ml-auto d-flex pt-3">
            <div>
                <div class="d-flex">
                    <div id="new_service_date-type" class="datetype-picker">
                        <div class="dropdown date-type-dropdown" #dtTrigger (click)="openDropdown('dt', dtTrigger)"
                            click-stop-propagation>
                            <span>{{'COMMON.DATE_TYPE.TITLE' | translate}}:</span>
                            <span>{{ selectedDateTypeDisplay | translate}}</span>
                            <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg"
                                    alt="Gray arrow down" /></span>
                        </div>
                        <div class="dropdown-opened" *ngIf="showSelectDateType" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
                            <div [id]="'new_service_date-type-' + (i + 1)" (click)="
                        selectDateType(dateType); (datesValid() == true && (dateTo || dateFrom)) && search()
                    " *ngFor="let dateType of dateTypes; let i = index">
                                <div>{{ dateType.translation | translate }}</div>
                            </div>
                        </div>
                    </div>
                    <div id="new_service_date-from" class="datepicker-container">
                        <label> {{'COMMON.FROM' | translate}}: </label>
                        <input type="date" id="dateFrom" name="dateFrom" class="date-input" [ngClass]="
                    !datesValid()
                        ? 'btn datepicker-icon-error'
                        : 'btn datepicker-icon'
                    " [(ngModel)]="dateFrom" (change)="datesValid() == true && search()" />
                    </div>

                    <div id="new_service_date-to" class="datepicker-container">
                        <label class="right-label"> {{'COMMON.TO' | translate}}: </label>
                        <input type="date" id="dateTo" name="dateTo" class="date-input" [ngClass]="
                    !datesValid()
                        ? 'btn datepicker-icon-error'
                        : 'btn datepicker-icon'
                    " [(ngModel)]="dateTo" (change)="datesValid() == true && search()" />
                    </div>
                </div>
            </div>
            <div id="new_service_sort-by" class="sort-by-root" #sbTrigger (click)="openDropdown('sb', sbTrigger)"
                click-stop-propagation>
                <div class="dropdown">
                    <span>{{'COMMON.SORT_BY.TITLE' | translate}}:</span>
                    <span>{{ sortByLabelValue.translation | translate
                        }}<img *ngIf="sortByLabelValue.arrow !== 'no'"
                            [ngClass]="{ 'arrow-up': sortByLabelValue.arrow === 'up' }"
                            src="../../../assets/icons/arrow.svg" /></span>
                    <span><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
                </div>
                <div class="dropdown-opened" *ngIf="showSortBy" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
                    <div id="new_service_sory-by-newest" (click)="sortBy(sortByOptions.NEWEST)">
                        <div>{{'COMMON.SORT_BY.NEWEST' | translate}}</div>
                    </div>
                    <div id="new_service_sory-by-oldest" (click)="sortBy(sortByOptions.OLDEST)">
                        <div>{{'COMMON.SORT_BY.OLDEST' | translate}}</div>
                    </div>
                </div>
            </div>
            <div #downloadWrapper *ngIf="permissionsService.isOnboardedCustomersDownloadAllowed">
                <div class="d-flex align-items-center data clickable nav-item"
                    style="border: 2px solid var(--primary-color)" #dlTrigger (click)="openDropdown('dl', dlTrigger)" click-stop-propagation>
                    <span>{{'COMMON.DOWNLOAD' | translate}}</span>
                    <div class="ms-auto">
                        <img class="arrow-icon" src="../../../assets/icons/dropdown.svg" />
                    </div>
                </div>

                <div *ngIf="showDownload" class="download-options" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
                    <div class="asset-grouped" [ngClass]="{
                            'selected-download': selectedKycDownloadReportType == KycDownloadReportType.OnboardedServiceRequestReport
                        }"
                        (click)="selectedKycDownloadReportType = KycDownloadReportType.OnboardedServiceRequestReport">
                        <span class="asset-name">{{'Onboarded Customers Report' | translate}}</span>
                    </div>

                    <div class="asset-grouped" [ngClass]="{
                            'selected-download': selectedKycDownloadReportType == KycDownloadReportType.OnboardedCustomerConsentReport
                        }"
                        (click)="selectedKycDownloadReportType = KycDownloadReportType.OnboardedCustomerConsentReport">
                        <span class="asset-name">{{'Customer Consent Report' | translate}}</span>
                    </div>

                    <button class="btn btn-primary btn-apply" (click)="download()">
                        <span>{{'COMMON.APPLY' | translate}}</span>
                    </button>
                </div>
            </div>
            <div *ngIf="permissionsService.isOnboardedCustomersAssignToVendorAllowed">
                <button class="btn btn-primary btn-upload" #bulkVendorTrigger (click)="openDropdown('bvu', bulkVendorTrigger)"
                    click-stop-propagation>
                    <img src="../../assets/icons/chevron-down.svg" alt="Chevron down" />
                </button>
                <div *ngIf="showBulkVendorUpload" class="xlsx-upload" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left" [routerLink]="'/upload/33/' + utilityId">
                    <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload icon" /></div>
                    <div>{{'NEW_SERVICE.BULK_ASSIGN_VENDOR' | translate}}</div>
                </div>
            </div>
            <button class="btn btn-primary btn-add-new" [title]="'NEW_SERVICE.BULK_ASSIGN_VENDOR' | translate" *ngIf="permissionsService.isOnboardedCustomersAssignToVendorAllowed">
                <img src="../../assets/icons/plus.svg" alt="Plus icon" />
                <span style="white-space: nowrap;">{{'NEW_SERVICE.BULK_ASSIGN_VENDOR' | translate}}</span>
            </button>
        </div>
        </div>
    </div>


    <div class="filter">
        <div class="filter-list">
            {{'COMMON.FILTER' | translate}}
            <app-multi-select-dropdown id="new_service_region_filter" class="multiselect" [clicked]="clicked"
                [items]="hasCimDataIntegration ? geographicalRegions : regions" [label]="'COMMON.BU.PLURAL'" [showMore]="false" [requireApply]="true"
                (shareIndividualCheckedList)="hasCimDataIntegration ? selectGeographicalRegion() : selectRegion()">
            </app-multi-select-dropdown>

            <app-multi-select-dropdown id="new_service_area-filter" class="multiselect" [clicked]="clicked"
                [items]="hasCimDataIntegration ? subGeographicalRegions : areas" [label]="'COMMON.UT.PLURAL'" [showMore]="false" [requireApply]="true"
                (shareIndividualCheckedList)="selectArea()">
            </app-multi-select-dropdown>

            <select [(ngModel)]="selectedSltStatus" (ngModelChange)="selectSltStatus($event)" class="form-select"
                [disabled]="isSltDropdownDisabled">
                <option [ngValue]="undefined" disabled>{{'NEW_SERVICE.SERVICE_TYPE' | translate}}</option>
                <option [id]="'new_service_service-type-' + (i + 1)" *ngFor="let s of sltOptions; let i = index"
                    [ngValue]="s.id">
                    {{ s.displayValue | translate }}
                </option>
            </select>
            <select [(ngModel)]="selectedSubserviceType" (ngModelChange)="selectSubserviceType($event)"
                class="form-select">
                <option [ngValue]="undefined" disabled>{{'NEW_SERVICE.SERVICE_REQUEST_TYPE' | translate}}</option>
                <option [id]="'new_service_service-type-' + (i + 1)"
                    *ngFor="let s of subServiceTypeOptions; let i = index" [ngValue]="s.value">
                    {{ s.displayValue | translate }}
                </option>
            </select>
            <select id="wo_scc_tag_filter" name="tag-select" (change)="selectKycTag($event)" class="form-select">
                <option value="" [selected]="!kycTag" disabled>
                    {{ "COMMON.TAG.TITLE" | translate }}
                </option>
                <option [id]="'wo_scc_tag_filter-' + (i + 1)" [selected]="kycTag == t.value"
                    *ngFor="let t of kycTagOptions; let i = index" value="{{ t.value }}">
                    {{ t.translation | translate }}
                </option>
            </select>
            <app-multi-select-dropdown id="new_service_project_status_filter" class="multiselect"
                [clicked]="clicked" [items]="projectTypeOptions" [label]="'NEW_SERVICE.PROJECT_STATUS'"
                [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectProjectType()">
            </app-multi-select-dropdown>
            <select [(ngModel)]="selectedAssignStatus"
                (ngModelChange)="selectAssignStatus($event)" class="form-select">
                <option [ngValue]="undefined" disabled>{{'NEW_SERVICE.ASSIGN_STATUS' | translate}}</option>
                <option [id]="'new_service_assign-status-' + (i + 1)"
                    *ngFor="let s of assignStatusOptions; let i = index" [ngValue]="s.value">
                    {{ s.displayValue | translate }}
                </option>
            </select>

            <app-multi-select-dropdown id="new_service_project-designation_filter"
                class="multiselect" [clicked]="clicked" [items]="projectDesignations"
                [label]="'NEW_SERVICE.PROJECT_DESIGNATIONS'" [showMore]="false" [requireApply]="true"
                (shareIndividualCheckedList)="selectProjectDesignation($event)">
            </app-multi-select-dropdown>
            <app-multi-select-dropdown *ngIf="organizations.length > 0" id="new_service_vendor_filter" class="multiselect" [clicked]="clicked"
                [items]="organizations" [label]="'NEW_SERVICE.ASSIGNED_VENDOR'" [showMore]="false" [requireApply]="true"
                (shareIndividualCheckedList)="selectVendor()">
            </app-multi-select-dropdown>
        </div>

        <div *ngIf="selectedFilters.length > 0">
            <app-filter-checklist [filters]="selectedFilters" [useApply]="true"
                (resetFilterEmitter)="resetFilter(true)" (removeFilterEmitter)="removeFilter($event)"
                (applyFilterEmitter)="applyFilter()">
            </app-filter-checklist>
        </div>
    </div>

    <div class="table table-overflow">
        <div>
            <table class="table">
                <thead class="table-light">
                    <tr>
                        <th id="new_service_table_header_checkbox">
                            <input type="checkbox" class="form-check-input" [ngModel]="allCheckboxesChecked"
                                (click)="checkAllCheckboxes()" />
                        </th>
                        <th id="new_service_table_header_app-num">{{'COMMON.TABLE_HEADERS.APP_NUM' | translate}}</th>
                        <th id="new_service_table_header_service_order_id">
                            {{ 'METER_REQUEST.SERVICE_ORDER_ID' | translate}}
                        </th>
                        <th id="new_service_table_header_acc-no">
                            {{'COMMON.CUSTOMER.ACCOUNT_NUMBER' | translate}}</th>
                        <th id="new_service_table_header_spn">
                            {{'COMMON.CONTRACT_NUMBER' | translate}}</th>
                        <th id="new_service_table_header_building-owner">{{'COMMON.TABLE_HEADERS.BUILDING_OWNER' |
                            translate}}</th>
                        <th id="new_service_table_header_region">{{'COMMON.BU.SINGLE' | translate}}</th>
                        <th id="new_service_table_header_district">{{'COMMON.UT.SINGLE' | translate}}</th>
                        <th id="new_service_table_header_feeder-band">{{'NEW_SERVICE.FEEDER_BAND' | translate}}</th>
                        <th id="new_service_table_header_feeder-name">{{'NEW_SERVICE.FEEDER_NAME' | translate}}</th>
                        <th id="new_service_table_header_dt-name">{{'NEW_SERVICE.DT_NAME' | translate}}</th>
                        <th id="new_service_table_header_address">{{'COMMON.ADDRESS' | translate}}</th>
                        <th id="new_service_table_header_sltStatus">{{'NEW_SERVICE.SERVICE_TYPE' | translate}}</th>
                        <th id="new_service_table_header_subserviceType">{{'NEW_SERVICE.SERVICE_REQUEST_TYPE' |
                            translate}}</th>
                        <th id="new_service_table_header_projectStatus">
                            {{'NEW_SERVICE.PROJECT_STATUS' | translate}}</th>
                        <th id="new_service_table_header_projectDesignation">
                            {{'NEW_SERVICE.PROJECT_DESIGNATION' | translate}}</th>
                        <th id="new_service_table_header_tag">Tag</th>
                        <th id="new_service_table_header_new_conn_status" class="text-nowrap">
                            {{'NEW_SERVICE.NEW_CONN_STATUS' | translate}}</th>
                        <th id="new_service_table_header_assigned_vendor" class="text-nowrap">
                            {{'NEW_SERVICE.ASSIGNED_VENDOR' | translate}}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr [id]="'new_service_table_row-' + (i + 1)" *ngFor="let accountKyc of accountKycs; let i = index">
                        <td [id]="'new_service_table_checkbox-' + (i + 1)"><input type="checkbox"
                                class="form-check-input" /></td>
                        <td [id]="'new_service_table_app-num-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.applicationNumber | hasValue }}
                        </td>
                        <td [id]="'new_service_table_app-num-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.serviceOrderId | hasValue }}
                        </td>
                        <td [id]="'new_service_table_acc-no-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.accountNumber | hasValue }}
                        </td>
                        <td [id]="'new_service_table_spn-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.spn | hasValue }}
                        </td>
                        <td [id]="'new_service_table_building-owner-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.buildingOwner | hasValue }}
                        </td>
                        <td [id]="'new_service_table_region-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ (hasCimDataIntegration ? accountKyc.geographicalRegion : accountKyc.region) | hasValue }}
                        </td>
                        <td [id]="'new_service_table_district-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ (hasCimDataIntegration ? accountKyc.subGeographicalRegion : accountKyc.area) | hasValue }}
                        </td>
                        <td [id]="'new_service_table_feeder-band-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ (hasCimDataIntegration ? accountKyc.acLineBand : accountKyc.feederBand) | hasValue }}
                        </td>
                        <td [id]="'new_service_table_feeder-name-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ (hasCimDataIntegration ? accountKyc.acLineName : accountKyc.feederName) | hasValue }}
                        </td>
                        <td [id]="'new_service_table_dt-name-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ (hasCimDataIntegration ? accountKyc.substationName : accountKyc.dtName) | hasValue }}
                        </td>
                        <td [id]="'new_service_table_address-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.address | hasValue }}
                        </td>
                        <td [id]="'new_service_table_serviceType-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.sltStatus | hasValue }}
                        </td>
                        <td [id]="'new_service_table_subserviceType-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.subserviceType | hasValue }}
                        </td>
                        <td [id]="'new_service_project_status-' + (i + 1)"
                            (click)="setFilterStorage()" [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.projectStatus | hasValue }}
                        </td>
                        <td [id]="'new_service_project_designation-' + (i + 1)"
                            (click)="setFilterStorage()" [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.projectDesignation | hasValue }}
                        </td>
                        <td [id]="'new_service_table_tag-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            <div class="building-status" [ngClass]="{
                                                        'orange-status v-2': accountKyc.tag == 'New Customer',
                                                        'green-status v-2': accountKyc.tag == 'Existing'
                                                    }">
                                {{ accountKyc.tag | hasValue }}
                            </div>
                        </td>
                        <td [id]="'new_service_table_new-conn-status-' + (i + 1)" (click)="setFilterStorage()"
                            [routerLink]="[routerLink, accountKyc.id]">
                            <div *ngIf="accountKyc.kycStatus === 'Pending'" class="gray-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.PENDING' | translate}}
                            </div>
                            <div *ngIf="accountKyc.kycStatus === 'Rejected'" class="dark-red-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.REJECTED' | translate}}
                            </div>
                            <div *ngIf="accountKyc.kycStatus === 'InProgress'" class="orange-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.INPROGRESS' | translate}}
                            </div>
                            <div *ngIf="accountKyc.kycStatus === 'Complete'" class="green-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.APPROVED' | translate}}
                            </div>
                            <div *ngIf="accountKyc.kycStatus === 'Suspended'" class="orange-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.SUSPENDED' | translate}}
                            </div>
                        </td>
                        <td [id]="'new_service_assigned-vendor' + (i + 1)"
                            (click)="setFilterStorage()" [routerLink]="[routerLink, accountKyc.id]">
                            {{ accountKyc.assignedVendor | hasValue }}
                        </td>
                        <td class="more-icon" (click)="setFilterStorage()">
                            <img src="../../assets/icons/more-icon.svg" alt="More icon" class="more-icon" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div>
        <app-paging *ngIf="count > 0" [pageSize]="pageSize" [useDirect]="true" [count]="count"
            [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-paging>
    </div>

</div>
